// The picker and access checks share this catalog so new raw dumps stay master-only.
export const PURCHASING_TABLES = {
  approval_outcome_notifications: "Approval Outcome Notifications",
  catalog_creation_policies: "Catalog Creation Policies",
  catalog_creation_requests: "Catalog Creation Requests",
  delivery_note_expenses: "Delivery Note Expenses",
  delivery_note_lines: "Delivery Note Lines",
  delivery_note_ocr_imports: "Delivery Note OCR Imports",
  delivery_note_ocr_logs: "Delivery Note OCR Logs",
  delivery_note_ocr_review_drafts: "Delivery Note OCR Review Drafts",
  delivery_notes: "Delivery Notes",
  inventory_accounting_closure_lines: "Inventory Accounting Closure Lines",
  inventory_accounting_closures: "Inventory Accounting Closures",
  inventory_balances: "Inventory Balances",
  inventory_count_lines: "Inventory Count Lines",
  inventory_count_location_lines: "Inventory Count Location Lines",
  inventory_counts: "Inventory Counts",
  inventory_entries: "Inventory Entries",
  inventory_item_par_levels: "Inventory Item Par Levels",
  inventory_layers: "Inventory Layers",
  inventory_location_balances: "Inventory Location Balances",
  inventory_location_incidents: "Inventory Location Incidents",
  inventory_location_monitor_notifications: "Inventory Location Monitor Notifications",
  inventory_location_monitor_settings: "Inventory Location Monitor Settings",
  inventory_locations: "Inventory Locations",
  inventory_movement_corrections: "Inventory Movement Corrections",
  inventory_movement_location_entries: "Inventory Movement Location Entries",
  inventory_movements: "Inventory Movements",
  inventory_receipt_openings: "Inventory Receipt Openings",
  inventory_snapshots: "Inventory Snapshots",
  ocr_item_learning: "OCR Item Learning",
  ocr_supplier_learning: "OCR Supplier Learning",
  ocr_supplier_patterns: "OCR Supplier Patterns",
  pos_purchasing_sales_sync_queue: "POS Purchasing Sales Sync Queue",
  purchase_order_approval_approver_rules: "Purchase Order Approval Approver Rules",
  purchase_order_approval_rule_steps: "Purchase Order Approval Rule Steps",
  purchase_order_approval_rules: "Purchase Order Approval Rules",
  purchase_order_approval_runs: "Purchase Order Approval Runs",
  purchase_order_approval_tasks: "Purchase Order Approval Tasks",
  purchase_order_approval_user_settings: "Purchase Order Approval User Settings",
  purchase_order_line_receipts: "PO Line Receipts",
  purchase_order_lines: "Purchase Order Lines",
  purchase_orders: "Purchase Orders",
  purchase_requisition_lines: "Purchase Requisition Lines",
  purchase_requisitions: "Purchase Requisitions",
  purchasing_catalog_records: "Purchasing Catalog Records",
  purchasing_catalog_unit_links: "Purchasing Catalog Unit Links",
  purchasing_categories: "Categories",
  purchasing_company_profiles: "Company Profiles",
  purchasing_distributors: "Purchasing Distributors",
  purchasing_equivalent_members: "Purchasing Equivalent Members",
  purchasing_equivalent_products: "Purchasing Equivalent Products",
  purchasing_families: "Families",
  purchasing_item_consumption_frequencies: "Purchasing Item Consumption Frequencies",
  purchasing_item_merges: "Purchasing Item Merges",
  item_suppliers: "Item Suppliers",
  purchasing_item_unit_changes: "Purchasing Item Unit Changes",
  purchasing_items: "Items",
  purchasing_menu_items: "Purchasing Menu Items",
  purchasing_pos_catalog_items: "Purchasing POS Catalog Items",
  purchasing_pos_catalogs: "Purchasing POS Catalogs",
  purchasing_pos_connections: "Purchasing POS Connections",
  purchasing_pos_item_links: "Purchasing POS Item Links",
  purchasing_pos_sale_lines: "Purchasing POS Sale Lines",
  purchasing_pos_sale_tickets: "Purchasing POS Sale Tickets",
  purchasing_recipe_equivalent_lines: "Purchasing Recipe Equivalent Lines",
  purchasing_recipe_lines: "Purchasing Recipe Lines",
  purchasing_recipes: "Purchasing Recipes",
  purchasing_requisition_templates: "Purchasing Requisition Templates",
  purchasing_subcategories: "Subcategories",
  purchasing_subfamilies: "Subfamilies",
  purchasing_supplier_distributors: "Purchasing Supplier Distributors",
  purchasing_supplier_identities: "Purchasing Supplier Identities",
  purchasing_supplier_invoice_ai_reviews: "Purchasing Supplier Invoice AI Reviews",
  purchasing_supplier_invoice_delivery_notes: "Purchasing Supplier Invoice Delivery Notes",
  purchasing_supplier_invoices: "Purchasing Supplier Invoices",
  purchasing_supplier_merges: "Purchasing Supplier Merges",
  purchasing_tender_agreement_lines: "Purchasing Tender Agreement Lines",
  purchasing_tender_agreements: "Purchasing Tender Agreements",
  purchasing_tenders: "Purchasing Tenders",
  purchasing_units: "Units",
  purchasing_whatsapp_inbox: "Purchasing WhatsApp Inbox",
  purchasing_whatsapp_sender_routes: "Purchasing WhatsApp Sender Routes",
  receivings: "Receivings",
  service_departments: "Service Departments",
  service_order_approval_policies: "Service Order Approval Policies",
  service_order_approval_runs: "Service Order Approval Runs",
  service_order_approval_tasks: "Service Order Approval Tasks",
  service_order_attachments: "Service Order Attachments",
  service_order_candidates: "Service Order Candidates",
  service_order_confirmations: "Service Order Confirmations",
  service_order_deliveries: "Service Order Deliveries",
  service_order_events: "Service Order Events",
  service_order_notifications: "Service Order Notifications",
  service_orders: "Service Orders",
  stock_approval_notifications: "Stock Approval Notifications",
  stock_dispatch_note_lines: "Stock Dispatch Note Lines",
  stock_dispatch_notes: "Stock Dispatch Notes",
  stock_document_approval_events: "Stock Document Approval Events",
  stock_requisition_lines: "Stock Requisition Lines",
  stock_requisition_policies: "Stock Requisition Policies",
  stock_requisitions: "Stock Requisitions",
  stock_return_events: "Stock Return Events",
  stock_return_lines: "Stock Return Lines",
  stock_returns: "Stock Returns",
  stock_transfer_lines: "Stock Transfer Lines",
  stock_transfer_policies: "Stock Transfer Policies",
  stock_transfer_policy_settings: "Stock Transfer Policy Settings",
  stock_transfers: "Stock Transfers",
  supplier_return_lines: "Supplier Return Lines",
  supplier_returns: "Supplier Returns",
  suppliers: "Suppliers",
  user_inventory_location_access: "User Inventory Location Access",
  user_item_access_rules: "User Item Access Rules",
};

// Preserve the existing API alias while displaying the physical table name.
export const purchasingTableName = (table) => table === "item_suppliers" ? "purchasing_item_suppliers" : table;
